
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyLightVessel as ObiSimplifiedBuoyLightVesselElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-light-vessel.js';
 
 
 

 
 export const ObiSimplifiedBuoyLightVessel = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-light-vessel',
   elementClass: ObiSimplifiedBuoyLightVesselElement,
   events: {
     
   }
  });
 
 